module.exports = __webpack_public_path__ + "static/media/NorthridgeFarms_masterdeed.ece54e14.pdf";